import {
    inject,
    observer,
} from 'mobx-react';
import {
    WithSnackbarProps,
} from 'notistack';
import React, {
    Component,
} from 'react';
import { FacilityStore } from 'mobx-store/stores/facilitiesStore';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
    TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import classes from './ratingFacilitiesBranchesList.scss';
import {
    CountryStore,
} from '../../mobx-store/stores/countryStore';
import { BranchStore } from '../../mobx-store/stores/branchStore';

interface IProps extends WithSnackbarProps {
    branchStore: BranchStore;
    countryStore: CountryStore;
    facilityStore: FacilityStore;
    match: any;
    history: any;
    location: any;
}

interface IState {
    branchId: number;
    areaId: number;
    categoryId: number;
    rating: number;
}

@inject('countryStore')
@inject('branchStore')
@inject('facilityStore')
@observer
class RatingFacilitiesBranchesList extends Component<IProps, IState> {
    tableHeader: any = [];
    tableData: any = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string = 'Facility Rating Branches';
    
    constructor(props: IProps) {
        super(props);
    }

    getFacilityTableHeader = () => {
        const headers = [
            {
                title: 'Branch',
            },
            {
                title: 'Average Rating',
            },
            {
                title: 'View',
            },
            {
                title: 'Statistics',
            },
            {
                title: 'Export',
            },
        ];

        return headers;
    }

    handleTableButtonCellClicked = (index: number, key: string) => {
        this.props.history.push(`/facilities/reports/branches/${this.props.branchStore.branchesRating[index].branchId}/areas`);
    };

    handleTableButtonStatisticsClicked = (index: number , key: string) => {
        this.props.history.push(`/facilities/reports/branches/${this.props.branchStore.branchesRating[index].branchId}/statistics`);
    };

    handleTableButtonExportClicked = async (index: number) => {
        await this.props.facilityStore.exportBranchFacilitiesRatings(
            this.props.branchStore.branchesRating[index].branchId,
            this.props.branchStore.branchesRating[index].branchTitle,
        );
    };


    getTableData = () => this.props.branchStore.branchesRating
    .map((branch) => ({
        ...branch,
        facilitiesRating: branch.facilitiesRating.toFixed(1),
        view: 'View Areas',
        statistics: 'Statistics',
        export: 'Export Ratings',
    }));

    getRatingFacilityTableCellTypes = (): TableCellTypes[] => {
        const cellTypes: TableCellTypes[] = [
            {
                cellType: 'Text',
                key: 'branchTitle',
            },
            {
                cellType: 'Text',
                key: 'facilitiesRating',
            },
            {
                cellType: 'Button',
                key: 'view',
                onClick: this.handleTableButtonCellClicked,
            },
            {
                cellType: 'Button',
                key: 'statistics',
                onClick: this.handleTableButtonStatisticsClicked,
            },
            {
                cellType: 'Button',
                key: 'export',
                onClick: this.handleTableButtonExportClicked,
            },
        ];

        return cellTypes;
    }

    initTable = () => {
        this.tableHeader = this.getFacilityTableHeader();
        this.tableCellTypes = this.getRatingFacilityTableCellTypes();        
        this.tableData = this.getTableData();
    };
    
    componentWillUnmount() {
        this.props.branchStore.branchesRating = [];
    }

    render() {
        this.initTable();

        return (
            <div className={classes.container}>
                <GeneralTableComponent
                    emptyMessage={'No Branches Ratings'}
                    title={this.title}
                    tableHeader={this.tableHeader}
                    tableData={this.tableData}
                    tableCellTypes={this.tableCellTypes}
                    loadingStatus={[
                        this.props.branchStore.getBranchesRequestStatus,
                        this.props.countryStore.getManagedCountriesRequestStatus
                      ]}
                />
            </div>
        );
    }

    async componentWillMount() {
        const {
            countryStore,
            branchStore,
        } = this.props;
        
        await countryStore.getUserManagedCountries();
        await branchStore.getBranchesRating(countryStore.managedCountries);        
        this.initTable();
    }
}

export default RatingFacilitiesBranchesList;
